// extracted by mini-css-extract-plugin
export default {"carouselSection":"PopularShows_carouselSection__I7Ieg","wrapper":"PopularShows_wrapper__NkW4W","carouselTitle":"PopularShows_carouselTitle__Ez9LI"};